import { render, staticRenderFns } from "./LibraryPage.vue?vue&type=template&id=3a8ef1c6&"
import script from "./LibraryPage.vue?vue&type=script&lang=js&"
export * from "./LibraryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports